"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var incrementParameter = function incrementParameter(num) {
  return ++num % 1000000;
};

var useUpdate = function useUpdate() {
  var _a = react_1.useState(0),
      setState = _a[1]; // useCallback with empty deps as we only want to define updateCb once


  return react_1.useCallback(function () {
    return setState(incrementParameter);
  }, []);
};

exports["default"] = useUpdate;